import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Swal from "sweetalert2";
import axios from "axios";
import GerarPdf from './gerar-pdf.js';
import GerarExcel from './gerar-excel.js';
import { toast } from "react-toastify";
import { BsCardHeading } from "react-icons/bs";
import { IoCloseSharp } from "react-icons/io5";
import { TbColumnInsertLeft } from "react-icons/tb";
import { FaPeopleArrows } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import './style.css';
import { parse, format } from 'date-fns';
import { TbReload } from "react-icons/tb";
import imagemTutorial from "../../../../styles/imagem/tutorial.jpg";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const Container = styled.div`
  display: flex;
  align-items: flex-start; 
  justify-content: flex-start; /* Alinha à esquerda para crescimento horizontal */
  flex-wrap: nowrap; /* Evita quebra de linha, permite crescimento horizontal */
  gap: 10px; 
  background-color: transparent;
  width: 100%;

  white-space: nowrap; /* Impede que o conteúdo quebre para a próxima linha */
  div {
    display: flex;
    flex-direction: row;
  }
`;
const ContainerColuna = styled.div`
  display: flex;
  align-items: flex-start; 
  justify-content: flex-start; 
  flex-wrap: nowrap;
  padding: 10px 10px 10px 10px; 
  gap: 10px; 
  background-color: transparent;
  width: 100%;
  min-height: 75px;
  max-height: calc(100vh - 132px); 
  height: 100vh;

  /* Lógica de scroll horizontal aplicada */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap; /* Impede quebra de linha */

  white-space: nowrap; /* Impede que os itens quebrem para a próxima linha */

  position: fixed; /* Fixa o elemento em relação à janela do navegador */
  bottom: 0; /* Mantém o elemento na parte inferior da viewport */
  left: 0;
  right: 0;
  overflow-y: hidden;
`;

const Box = styled.div`
  flex: 0 0 300px; /* Define largura fixa de 300px */
`;

const DivBox = styled.div`
  width: 310px;
  max-height: 77vh;
  flex: 1;
  padding: 7px;
  border: 1px solid #ccc;
  text-align: start;
  box-sizing: border-box;
  margin: 5px;

  background: #f4f4f5; 
  border-radius: 10px; /* Bordas arredondadas */
  backdrop-filter: blur(10px); /* Efeito de desfoque */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Sombra leve */
  transition: transform 0.1s, background 0.3s;

  h3 {
    
    color: #3a3f42;
  }
  
  p {
    
    color: #3a3f42;
  }

  
`;
const DivLista = styled.div`
  max-height: 63vh;
  overflow-y: scroll;
  
`;
const DivCabecario = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; 
  height: 40px;

  h3 {
    padding-left: 5%;
    white-space: normal; /* Permite quebras de linha automáticas */
    word-break: break-word; /* Quebra a palavra quando não cabe na linha */
  }
  
`;
const DivCabecarioInt = styled.div`
  display: flex;
  flex-direction: row;
`;
const DivCabecarioInt2 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 90px;
`;



const Div = styled.div`
  display: flex;
  width: 250px;
  flex-direction: column;
  align-items: start;
  margin: auto;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  min-height: 80px;
  background-color: #f4f4f5;
  margin-top: 10px;
  border-radius: 5px;
  cursor: pointer;
  border-radius: 10px; /* Bordas arredondadas */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Sombra leve */

  &:hover {
    box-shadow: 0 4px 6px gray;
  }
  
 
  p {
    color: #3a3f42;
    overflow-wrap: break-word; /* Quebra palavras longas */
    white-space: normal; /* Permite que o texto quebre em várias linhas */
  }
`;

const TextContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Alinha o conteúdo ao início */
  justify-content: flex-start; /* Garante que o conteúdo fique no topo */
  white-space: normal; /* Permite quebra de linha no texto */
`;

const Divdata = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start; /* Mantém os itens no topo */
  width: 100%;
  div {
    display: flex;
    flex-direction: row;
    color: #3a3f42;
    justify-content: start;
    align-items: center;
    gap: 5px;
  }
`;

const P = styled.p`
  font-size: 17px;
  color: #3a3f42;
  overflow-wrap: break-word; /* Quebra palavras longas */
  white-space: normal; /* Permite que o texto quebre em várias linhas */
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #3a3f42;
  font-size: 18px;
  gap: 5px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }

`;

const Button2 = styled.button`
  display: flex;
  align-items: center;

  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #3a3f42;
  font-size: 20px;

  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }

`;



const DivButtons = styled.div`

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  margin-left: 15px;
  p{
    font-size: 18px;
  }
`;
const Input = styled.input`
  width:300px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 10px; 
  height: 27px;
  font-size: 20px;
  height: 36px;
  background-color: #f4f4f5;
  color: #3a3f42;
  margin-top: 10px;
`;
const ButtonNew = styled.button`
  width: 150px; /* Expande no hover */
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #3a3f42;
  font-size: 20px;
  gap: 5px; /* Ajusta o espaçamento */
  margin-top: 10px;

`;



const SwitchContainer = styled.label`
  display: flex;
  align-items: center;
  font-size: 18px;
  user-select: none;
`;

const SwitchInput = styled.input`
  display: none; /* Esconde o input padrão */
`;

const SwitchSlider = styled.span`
  width: 50px;
  height: 25px;
  background: ${({ ativo }) => (ativo ? "#076333" : "#ccc")}; /* Verde para "Sim", cinza para "Não" */
  border-radius: 25px;
  position: relative;
  transition: 0.3s;
  cursor: pointer;
  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    top: 2.5px;
    left: ${({ ativo }) => (ativo ? "26px" : "4px")}; /* Move a bolinha */
    transition: 0.3s;
  }
`;

const Div2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 7px 0px 10px 20px;
  gap: 5px;
  p {
    margin-right: 5px;
    color: #575757;
  }
`;


const Grid = ({ setVerQuadro, urlApi, colunas, card, modalNovoCard, fetchCard, fetchColunas, modalEditarCartao, modalNovaColuna, verQuadro, modalCompartilhar, criador, modalEditarNomeLista }) => {

  const token = localStorage.getItem('token');


  //---------------------------------------------------------------------------------------------------------------//
  //Cria nova coluna
  const handleNovoCard = (coluna) => {
    modalNovoCard(coluna)
  };


  //------------------------------------------------CONFIRMAR A EXCLUIR---------------------------------------------------------------//
  //Deletar lista e cartão
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de continuar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };

  //---------------------------CONTROLA A VISUALIZAÇÂO DO BOTÂO EXCLUIR----------------------------------//
  const [excluir, setExcluir] = useState(false)
  const handleExcluir = async () => {
    setExcluir(true);
  };

  //-------------------------------EXCLUIR A LISTA------------------------------------------------//

  const handleExcluirLista = async (coluna) => {
    const userConfirmed = await showPopUp();
    if (!userConfirmed) return;

    try {
      await axios.delete(`${urlApi}painel-monitoramento/deleta-lista/${coluna.ID_LISTA}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      fetchColunas();
      setExcluir(false);
      toast.success("Lista excluída com sucesso.");
    } catch (error) {
      console.error("Erro ao deletar lista:", error);

      const errorMessage = error.response?.data?.error || "Erro desconhecido ao deletar.";
      toast.error(errorMessage);
    }
  };

  //-------------------------EXCLUI O CARTÃO------------------------------------------------------//
  const handleExcluirCartao = async (card) => {
    const userConfirmed = await showPopUp();
    if (!userConfirmed) return;

    try {
      await axios.delete(`${urlApi}painel-monitoramento/deletar-cartao/${card.ID_CARTAO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Cartão deletado com sucesso.");
      fetchCard();
      setExcluir(false);
    } catch (error) {
      let errorMessage = 'Erro ao deletar cartão.';

      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
        console.error("Erro:", error.response);
      } else {
        console.error("Erro genérico:", error.message);
      }

      toast.error(errorMessage);
    }
  };




  //---------------------------------------------------------------------------------------------------------------//
  //Editar cartão
  const handleEdit = (card) => {
    modalEditarCartao(card)
  };

  //Abre o modal 'Nova lista'
  const handleNovaColuna = () => {
    modalNovaColuna()
  };

  //Abre o compartilhar usuário
  const handleCompartilhar = () => {
    modalCompartilhar()
  };

  //Abre o alterar nome lista
  const handleEditarNomeLista = (coluna) => {
    modalEditarNomeLista(coluna)
  };

  //Filtrando o quadros com verQuadro.id_quadro
  const filtrandoCards = card.filter((c) => c.id_quadro === verQuadro.id_quadro);






  //states do pesquisar
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [filtrandoCards2, setFiltrandoCards2] = useState(card);


  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = filtrandoCards.filter((user) => {
        const columnsToSearch = [
          'TITULO_CARTAO',
          'SITUACAO_LEGIVEL',
        ];

        // Verifica se algum dos valores nas colunas contém o termo de pesquisa
        return columnsToSearch.some((column) => {
          const columnValue = user[column] ? user[column].toLowerCase() : '';
          return columnValue.includes(term.toLowerCase());
        });
      });
      setFiltrandoCards2(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    handleSearch(searchTerm);

  }, [searchTerm, card]);


  //--------------------------------------QUADRO EDITAVEL------------------------------//
  // Controla o efeito do toggle
  const handleToggle = () => {
    const novoValor = verQuadro.LIVRE === "S" ? "N" : "S";

    // Atualiza o estado com o novo valor
    setVerQuadro((prev) => ({
      ...prev,
      LIVRE: novoValor,
    }));

    // Chama a função para atualizar no banco
    handleEditarQuadro(novoValor);
  };
  //-----------------------------------FUNÇÂO QUE ALTERA O QUADRO PARA EDITAVEL--------------------//
  // Função que altera o quadro para editável ou não
  const handleEditarQuadro = async (LIVRE) => {
    try {
      await axios.put(
        `${urlApi}painel-monitoramento/pode-editar-quadro/${verQuadro.ID_QUADRO}`,
        { LIVRE }, // Envia o novo valor corretamente
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Alteração salva com sucesso!");
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };




  /*
  // janela que mostra as novidades
  const showPopUpNovidades = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Marcando a opção 'Sim', os participantes do quadro podem criar, editar e deletar listas, cartões e tarefas.",

        imageUrl: imagemTutorial, // URL da imagem
        imageWidth: "90%", // Ajusta a largura da imagem
        imageAlt: "Imagem ilustrativa",
        html: `
         
          <div style="text-align: left; margin-top: 15px; color: #3a3f42; font-size: 16px;">
            <input type="checkbox" id="doNotShowAgain" style="margin-right: 8px;">
            <label for="doNotShowAgain">Não mostrar novamente</label>
          </div>
        `,
        showConfirmButton: true, // Exibe apenas um botão
        confirmButtonText: "Entendi",
        allowOutsideClick: false, // Impede fechar clicando fora
        customClass: {
          popup: "custom-swal-popup",
          title: "custom-swal-title",
          confirmButton: "custom-swal-confirm-button",
        },
        preConfirm: () => {
          const checkbox = document.getElementById("doNotShowAgain");
          if (checkbox && checkbox.checked) {
            localStorage.setItem("popupDismissed2", "true");
          }
        },
      }).then(() => resolve(true));
    });
  };

  // Exibe o pop-up se ainda não foi dispensado
  useEffect(() => {
    if (!localStorage.getItem("popupDismissed2")) {
      showPopUpNovidades();
    }
  }, []);

  */


  //--------------------------ORDENA A COLUNA-----------------------------------------//

  //Mover as colunas e salvar
  const [novaOrdem, setNovaOrdem] = useState([]);
  let colunasFiltradas = null;
  useEffect(() => {
    // Atualiza novaOrdem sempre que colunas ou verQuadro.id_quadro mudar
    setNovaOrdem(colunas);
  }, [colunas, verQuadro.id_quadro]);

  const handleDragEnd = async (result) => {
    if (!result.destination) return; // Se soltar fora da área, não faz nada

    const startIndex = result.source.index;
    const endIndex = result.destination.index;

    // Criar uma cópia do estado atualizado
    const reorderedColunas = [...novaOrdem];
    const [movedItem] = reorderedColunas.splice(startIndex, 1);
    reorderedColunas.splice(endIndex, 0, movedItem);

    setNovaOrdem(reorderedColunas);

    // Salvar a nova ordem no banco
    await atualizarPosicoesNoBanco(reorderedColunas);
  };
  //--------------------------ALTERAR A POSIÇÂO-----------------------------------------//
  const atualizarPosicoesNoBanco = async (novasColunas) => {
    try {
      const colunasAtualizadas = novasColunas.map((coluna, index) => ({
        id_coluna: coluna.ID_LISTA,
        posicao: index + 1,
      }));

      const token = localStorage.getItem("token");

      await axios.put(
        `${urlApi}painel-monitoramento/atualizar-posicao-lista`,
        { colunas: colunasAtualizadas },
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      // Agora busca os dados atualizados
      fetchColunas();

    } catch (error) {
      console.error("Erro ao atualizar posições no banco:", error);
    }
  };








  return (
    <div>
      <Container>
        <DivButtons>
          {(criador || verQuadro.LIVRE === "S") && (
            <>
              <ButtonNew
                onClick={handleNovaColuna}
                title="Cria nova lista"
              >
                <TbColumnInsertLeft />
                <span>Adicionar lista</span>
              </ButtonNew>


              <ButtonNew onClick={handleCompartilhar} title="Compartilhar o quadro com outros usuários">
                <FaPeopleArrows />
                <span>Compartilhar</span>
              </ButtonNew>
            </>

          )}

          <Input
            type="text"
            placeholder="Pesquisar titulo e situação..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <p>
            Participantes podem editar:{" "}
            <strong style={{ margin: "10px" }}>
              {verQuadro.LIVRE === "S" ? "Sim" : "Não"}
            </strong>
          </p>


          {criador && (
            <SwitchContainer>
              <SwitchInput type="checkbox" checked={verQuadro.LIVRE === "S"} onChange={handleToggle} />
              <SwitchSlider ativo={verQuadro.LIVRE === "S"} />
            </SwitchContainer>
          )}
          <Div2>

            <p>Exportar: </p>
            <GerarPdf filtrandoCards={filtrandoCards2} colunasFiltradas={colunasFiltradas} verQuadro={verQuadro} colunas={colunas} />
            <GerarExcel filtrandoCards={filtrandoCards2} colunasFiltradas={colunasFiltradas} verQuadro={verQuadro} colunas={colunas} />

          </Div2>

        </DivButtons>



      </Container>



      <DragDropContext onDragEnd={criador ? handleDragEnd : () => { }}>
        <Droppable droppableId="colunas" direction="horizontal">
          {(provided) => (
            <ContainerColuna
              className="scroll"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {novaOrdem
                .filter(coluna => coluna && coluna.ID_LISTA !== undefined)
                .map((coluna, index) => (
                  <Draggable
                    key={coluna.ID_LISTA.toString()}
                    draggableId={coluna.ID_LISTA.toString()}
                    index={index}
                    isDragDisabled={!criador}
                  >
                    {(provided) => (
                      <Box
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="coluna"
                      >
                        <DivBox>
                          <DivCabecario>
                            <h3>{coluna.DESCRICAO_LISTA}</h3>
                            <DivCabecarioInt>
                              {(criador || verQuadro.LIVRE === "S") && (
                                <Button2
                                  title="Alterar"
                                  onClick={() => handleEditarNomeLista(coluna)}
                                  type="button"
                                >
                                  <MdModeEdit />
                                </Button2>
                              )}
                              {excluir && (criador || verQuadro.LIVRE === "S") && (
                                <Button2
                                  onClick={() => handleExcluirLista(coluna)}
                                  title="Excluir"
                                  type="button"
                                >
                                  <IoCloseSharp color="red" size={25} />
                                </Button2>
                              )}
                            </DivCabecarioInt>
                          </DivCabecario>


                          {/* Filtrando e renderizando os cards que pertencem a essa coluna */}
                          <DivLista className='scroll'>

                            {filtrandoCards2
                              .filter((card) => card.ID_LISTA === coluna.ID_LISTA) // Filtra os cards com base no id_coluna
                              .map((card) => ( // Renderiza os cards filtrados
                                <Div key={card.id_card} className="card" onClick={() => handleEdit(card)} type="button">
                                  <TextContainer >
                                    <P title='Titulo do cartão'>{card.TITULO_CARTAO}</P>
                                  </TextContainer>

                                  <Divdata>
                                    <div>
                                      {card.DATA_CONCLUSAO ? (
                                        <P title='Data de entrega do cartão'>{card.DATA_CONCLUSAO_LISTA}</P>
                                      ) : (
                                        <P></P>
                                      )}
                                      {card.RECORRENTE === 'S' ? (
                                        <TbReload title='Esse cartão é recorrente' />
                                      ) : (
                                        <P></P>
                                      )}
                                    </div>
                                    <P title='Situação do cartão'>{card.SITUACAO_LEGIVEL}</P>
                                    {excluir && (criador || verQuadro.LIVRE === "S") && (
                                      <Button2
                                        onClick={(event) => {
                                          event.preventDefault(); // Impede o comportamento padrão
                                          event.stopPropagation(); // Impede a propagação do evento para o Div pai
                                          handleExcluirCartao(card);
                                        }}
                                        title="Excluir"
                                        type="button"
                                      >
                                        <IoCloseSharp color={"red"} size={25} />
                                      </Button2>
                                    )}
                                  </Divdata>

                                </Div>
                              ))}
                          </DivLista>

                          <DivCabecario>
                            {(criador || verQuadro.LIVRE === "S") && (
                              <DivCabecarioInt2>
                                <Button onClick={() => handleNovoCard(coluna)} title="Cria novo cartão">
                                  <BsCardHeading /> Adicionar cartão
                                </Button>
                                {!excluir && (
                                  <Button onClick={() => handleExcluir()} title="Excluir">
                                    <IoCloseSharp />
                                  </Button>
                                )}
                              </DivCabecarioInt2>
                            )}
                          </DivCabecario>

                        </DivBox>
                      </Box>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </ContainerColuna>
          )}
        </Droppable>
      </DragDropContext>

    </div>

  );
};

export default Grid;
